/* unplugin-vue-components disabled */import script from "./footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer.vue?vue&type=script&setup=true&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=2736f4c0&lang=less&scoped=true"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2736f4c0"]])

export default __exports__